<template>
  <component :is="el" :label="label" :prop="prop" :required="required">
    <div v-if="disabled" class="html-remarks">
      <p v-if="formData" :style="'height: ' + height / 2 + 'px;'"  v-safe-html="formData"></p>
    </div>
    <div v-else>
      <!-- XOL-596: focus / blur are re-emitted (additive) so a request drawer can
           hold the field while it is being edited. vue-quill-editor emits both
           from quill's selection-change. -->
      <quill-editor v-model="formData" :options="editorOptions" :style="'height: ' + height + 'px; width: ' + width + '; overflow: auto;'"  @change="updated" @focus="$emit('focus')" @blur="$emit('blur')" />
    </div>
  </component>
</template>

<script>
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'

import { quillEditor } from 'vue-quill-editor'

export default {
  name: 'html-input',

  components: {
    quillEditor
  },



  props: {

    label: {
      type: String,
      default: null
    },

    value: {
      required: true
    },

    height: {
      type: [Number, String],
      default: 222
    },

    width: {
      type: [Number, String],
      default: 'auto'
    },

    disabled: {
      type: Boolean,
      default: false
    },

    required: {
      type: Boolean,
      default: false
    },

    showImage: {
      type: Boolean,
      default: true
    },

    showEmptyMessage: {
      type: Boolean,
      default: false
    },

    placeholder: {
      type: String,
      default: null
    },

    helpText: {
      type: String,
      default: null
    },

    prop: {
      type: String,
      default: null
    },

    noForm: {
      type: Boolean,
      default: false
    }

  },



  methods: {

    updated (value) {
      // XOL-596: only a change the USER made is an edit. vue-quill-editor's own
      // value watcher re-pastes whenever the parent's value changes (an adopt, a
      // parked server value applied on release, "Use their version") and quill
      // answers with a text-change carrying the NORMALISED html (`null` becomes
      // '', `x` becomes '<p>x</p>'). Re-emitting that would make every
      // programmatic change look like a keystroke: a save of normalised html
      // under the wrong user, and a false 409 for the real author. The editor
      // keeps its own copy (v-model on `formData`); the parent hears nothing.
      if (this.applying || this.disabled) {
        return
      }
/*
      if (value) {
        // Remove any residual html codes, after deleting the text in the editor
        var regexp = /<\/?\w+((\s+\w+(\s*=\s*(?:".*?"|'.*?'|[^'">\s]+))?)+\s*|\s*)\/?>/gi
        var text = value.replace(regexp, '').trim()

        if (!text) {
          value = null
        }
      }
*/
      this.$emit('input', value.html)
      this.$emit('change', value.html)
    }
  },

  watch: {
    value: function (val) {
      // The editor re-pastes `val` in the same flush (vue-quill-editor's own
      // watcher) and its text-change comes back synchronously, so everything
      // `updated` hears until the next tick is that paste, not the user.
      this.applying = true
      this.formData = val
      this.$nextTick(() => { this.applying = false })
    }
  },

  created () {
    // Not reactive: read only by `updated`.
    this.applying = false
  },


  data () {
    return {
      formData: this.value,
      el: this.noForm ? 'div' : 'el-form-item',

      editorOptions: {
        modules: {
          toolbar: [
            ['bold', 'italic', 'underline', 'strike'],        // toggled buttons
            ['blockquote', 'code-block'],

            [{'header': 1}, {'header': 2}],               // custom button values
            [{'list': 'ordered'}, {'list': 'bullet'}],
            [{'script': 'sub'}, {'script': 'super'}],      // superscript/subscript
            [{'indent': '-1'}, {'indent': '+1'}],          // outdent/indent
            [{'direction': 'rtl'}],                         // text direction

            [{'size': false}],  // custom dropdown
            [{'header': [1, 2, 3, 4, 5, 6, false]}],

            [{'color': []}, {'background': []}],          // dropdown with defaults from theme
            [{'font': []}],
            [{'align': []}],

            [{'image': this.showImage}, {'clean': true}]
          ]
        }
      }
    }
  }

}
</script>
